import { getReferralFromFileType } from './getReferralFromFileType';
import { getReferralFromSubstrateInfo } from './getReferralFromSubstrateInfo';
export function getReferralFromDocument(document) {
    if (document.substrateInfo) {
        return getReferralFromSubstrateInfo(document.substrateInfo);
    }
    else {
        return getReferralFromFileType(document.fileType);
    }
}
//# sourceMappingURL=getReferralFromDocument.js.map